import ArrowBack from "@mui/icons-material/ArrowBack";
import { Box, IconButton, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

type ChatHeaderProps = {
  title: string;
  showBack?: boolean;
  onBack?: () => void;
};

export function ChatHeader({ title, showBack = false, onBack }: ChatHeaderProps) {
  const { t } = useTranslation("chat");

  return (
    <Box
      sx={{
        mb: 2,
        color: "var(--theme-text-primary)",
        display: "flex",
        alignItems: "center",
        gap: 1,
      }}
    >
      {showBack ? (
        <IconButton
          aria-label={t("backAria")}
          onClick={onBack}
          size="small"
          sx={{
            color: "var(--theme-text-primary)",
            "&:hover": {
              bgcolor: "var(--theme-hover-secondary)",
            },
          }}
        >
          <ArrowBack />
        </IconButton>
      ) : null}
      <Typography variant="h4" component="h1" sx={{ fontWeight: 700, letterSpacing: -0.5 }}>
        {title}
      </Typography>
    </Box>
  );
}
